import React, { useState, useEffect } from 'react';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import styled from 'styled-components';
import { PageContentWrapper, PageHeader, PageDescription } from '../main/LayoutStyles';
import { KnowledgeBaseGrid, ArticleCardStyled } from './KnowledgeStyles';
import { StyledButton, AlertBox } from '../main/CommonStyles';
import { Loader2, AlertTriangle, PlusCircle } from 'lucide-react';
import apiClient from '../services/api';
import { useAuth } from '../auth/AuthContext';
import { useFeatures } from '../feature/FeatureContext'; // NOWY IMPORT

const KnowledgeHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: ${({ theme }) => theme.spacing.lg};
    flex-wrap: wrap;
    gap: 1rem;
`;

const HeaderInfo = styled.div`
    flex: 1;
    min-width: 300px;
`;

const KnowledgePage = () => {
    const { isPsychologist } = useAuth();
    const { features } = useFeatures(); // NOWY IMPORT
    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const fetchArticles = async () => {
            setLoading(true);
            setError('');
            try {
                const response = await apiClient.get('/articles');
                setArticles(response.data);
            } catch (err) {
                setError(err.response?.data?.message || 'Nie udało się załadować artykułów.');
                console.error("Błąd ładowania artykułów:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchArticles();
    }, []);

    const handleArticleClick = (slug) => {
        navigate(`/app/knowledge/${slug}`);
    };

    return (
        <PageContentWrapper className="custom-scrollbar">
            <KnowledgeHeader>
                <HeaderInfo>
                    <PageHeader>Baza Wiedzy</PageHeader>
                    <PageDescription>
                        Zapoznaj się z artykułami i materiałami na temat zdrowia psychicznego, emocji,
                        radzenia sobie ze stresem i budowania odporności psychicznej.
                    </PageDescription>
                </HeaderInfo>
                {/* ZMIANA: Sprawdzamy rolę ORAZ flagę funkcji */}
                {isPsychologist && features.ARTICLE_CREATION && (
                    <StyledButton as={RouterLink} to="/app/create-article">
                        <PlusCircle size={18} />
                        Dodaj nowy artykuł
                    </StyledButton>
                )}
            </KnowledgeHeader>

            {loading && (
                <div style={{ textAlign: 'center', paddingTop: '20px' }}>
                    <Loader2 size={32} className="icon-spin" />
                    <p>Ładowanie artykułów...</p>
                </div>
            )}

            {error && <AlertBox type="error"><AlertTriangle /> {error}</AlertBox>}

            {!loading && !error && (
                <KnowledgeBaseGrid>
                    {articles.map(article => (
                        <ArticleCardStyled key={article.id} onClick={() => handleArticleClick(article.slug)}>
                            {article.imageUrl ? (
                                <img
                                    src={article.imageUrl}
                                    alt={article.title}
                                    className="article-card-image"
                                />
                            ) : (
                                <div className="article-image-placeholder">Brak obrazka</div>
                            )}
                            <div className="article-card-content">
                                {article.category && <p className="article-category">{article.category}</p>}
                                <h3>{article.title}</h3>
                                <p className="article-snippet">{article.snippet}</p>
                            </div>
                        </ArticleCardStyled>
                    ))}
                </KnowledgeBaseGrid>
            )}
        </PageContentWrapper>
    );
};

export default KnowledgePage;